function compareVersion(currentVersion, comparativeVersion) {
  const splitVersion = currentVersion.split(".");
  const splitComparativeVersion = comparativeVersion.split(".");
  for (let i = 0; i < splitVersion.length; i++) {
    if (Number(splitVersion[i]) < Number(splitComparativeVersion[i])) {
      return -1;
    }
    if (Number(splitVersion[i]) > Number(splitComparativeVersion[i])) {
      return 1;
    }
  }
  return 0;
}
function isEqualTo(currentVersion, comparativeVersion) {
  return compareVersion(currentVersion, comparativeVersion) === 0;
}
function isGreaterThan(currentVersion, comparativeVersion) {
  return compareVersion(currentVersion, comparativeVersion) === 1;
}
function isGreaterThanOrEqualTo(currentVersion, comparativeVersion) {
  const result = compareVersion(currentVersion, comparativeVersion);
  return result === 0 || result === 1;
}
function isLessThan(currentVersion, comparativeVersion) {
  return compareVersion(currentVersion, comparativeVersion) === -1;
}
function isLessThanOrEqualTo(currentVersion, comparativeVersion) {
  const result = compareVersion(currentVersion, comparativeVersion);
  return result === -1 || result === 0;
}
export {
  compareVersion,
  isEqualTo,
  isGreaterThan,
  isGreaterThanOrEqualTo,
  isLessThan,
  isLessThanOrEqualTo
};
